export const ALLOWED_DOC_ATTACHMENT_FILE_FORMATS = [
  'jpg',
  'zip',
  'rar',
  '7z',
  'arc',
  'arj',
  'jar',
  'tar',
  'doc',
  'docx',
  'jpeg',
  'png',
  'xls',
  'xlsx',
  'scv',
  'ppt',
  'txt',
  'rtf',
  'pdf',
  'tiff',
  'tif',
  'dotx',
  'docx',
  'odt',
  'dot',
  'sxw',
  'ott',
  'stw',
  'ods',
  'sxc',
  'ots',
  'stc',
  'xlt',
  'csv',
  'odp',
  'stc',
  'ppt',
  'pps',
  'pot',
  'html',
  'xodt',
  'docm',
  'odt',
  'ott',
  'xott',
  'xods',
  'ods',
  'tsv',
  'scsv',
  'xltx',
  'xlt',
  'xlsm',
  'ots',
  'tab',
  'xots',
  'xodp',
  'pptx',
  'pptm',
  'ppsx',
  'potx',
  'otp',
  'xotp',
  'tgz',
  'gz',
  'webp',
];
